import { render, staticRenderFns } from "./AmazonListing.vue?vue&type=template&id=32e23612&scoped=true"
import script from "./AmazonListing.vue?vue&type=script&lang=js"
export * from "./AmazonListing.vue?vue&type=script&lang=js"
import style0 from "./AmazonListing.vue?vue&type=style&index=0&id=32e23612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e23612",
  null
  
)

export default component.exports